export default "__VITE_ASSET__Vq4YayYP__"